export function buildScheduleTagOptions(definitions = [], currentTags = []) {
    const normalizedCurrentTags = Array.isArray(currentTags) ? currentTags : [];
    const currentKeys = new Set(normalizedCurrentTags.map((tag) => String(tag).trim().toLocaleLowerCase()));
    const options = definitions
        .filter((definition) => definition.is_active || currentKeys.has(String(definition.tag_name).toLocaleLowerCase()))
        .map((definition) => ({ value: definition.tag_name, label: definition.tag_name }));
    const optionKeys = new Set(options.map((option) => option.value.toLocaleLowerCase()));
    normalizedCurrentTags.forEach((tag) => {
        const normalized = String(tag || "").trim();
        if (normalized && !optionKeys.has(normalized.toLocaleLowerCase())) {
            options.push({ value: normalized, label: normalized });
            optionKeys.add(normalized.toLocaleLowerCase());
        }
    });
    return options;
}

export function buildScheduleTagFilterOptions(activeDefinitions = []) {
    return activeDefinitions.map((definition) => ({
        value: definition.tag_name,
        label: definition.tag_name,
    }));
}
